import isEmail from 'validator/lib/isEmail';

export const studentRegisterErrorMessages = {
	titleError: 'Prosimy o wybór tytułu.',
	nameError: 'Prosimy o uzupełnienie imienia.',
	parentNameError: 'Prosimy o uzupełnienie imienia i nazwiska rodzica/opiekuna prawnego.',
	secondNameError: 'Prosimy o uzupełnienie drugiego imienia.',
	surnameError: 'Prosimy o uzupełnienie nazwiska.',
	classError: 'Prosimy o wybór klasy.',
	specializationError: 'Prosimy o wybór specjalizacji.',
	emailError: 'Prosimy o podanie poprawnego adresu e-mail.',
	phoneError: 'Prosimy o podanie numeru telefonu.',
	schoolError: 'Prosimy o wybór szkoły.',
	districtError: 'Prosimy o wybór okręgu.',
	teacherError: 'Prosimy o wybór nauczyciela.',
	streetError: 'Prosimy o uzupełnienie ulicy.',
	buildingError: 'Prosimy o uzupełnienie numeru budynku.',
	apartmentError: '',
	zipCodeError: 'Prosimy o podanie poprawnego kodu pocztowego.',
	cityError: 'Prosimy o uzupełnienie miasta.',
	rodoError: 'Prosimy o zaznaczenie wymaganych zgód.',
	consentError: 'Prosimy o zaznaczenie wymaganych zgód.',
	passwordError: 'Hasło musi mieć co najmniej 8 znaków.',
	passwordConfirmError: 'Hasła muszą być identyczne.',
};

export type StudentRegisterValidation = {
	[K in keyof typeof studentRegisterErrorMessages]: string;
};

export function emptyStudentRegisterValidation(): StudentRegisterValidation {
	return {
		titleError: '',
		nameError: '',
		parentNameError: '',
		secondNameError: '',
		surnameError: '',
		classError: '',
		specializationError: '',
		emailError: '',
		phoneError: '',
		schoolError: '',
		districtError: '',
		teacherError: '',
		streetError: '',
		buildingError: '',
		apartmentError: '',
		zipCodeError: '',
		cityError: '',
		rodoError: '',
		consentError: '',
		passwordError: '',
		passwordConfirmError: '',
	};
}

function strField(value: unknown): string {
	if (value === null || value === undefined) {
		return '';
	}
	return String(value).trim();
}

type StudentFormSlice = {
	personalTitle: string;
	parentName: string;
	parentEmail: string;
	firstName: string;
	secondName: string;
	lastName: string;
	class: number | string;
	specializationId: string | number;
	email: string;
	phone: string;
	districtId: string | number;
	teachersIds: unknown[];
	scientificTeacherIds?: unknown[];
	schoolTeacherId?: number | null;
	street: string;
	building: string;
	apartment: string;
	zipCode: string;
	city: string;
	schoolId: string | number;
	isStudentUnderage: boolean;
	password: string;
	passwordConfirm: string;
};

type HelperSlice = {
	district: string;
	school: string;
	specialization: string;
	rodo: string | boolean;
	consent: string | boolean;
};

/** Walidacja spójna z handlerami pól — używana po prefill i przy submit. */
export function computeStudentRegisterValidation(args: {
	formInfo: StudentFormSlice;
	helperInputInfo: HelperSlice;
	isSecondName: boolean;
	isSmallOlympic: boolean;
	skipPassword: boolean;
	guardianRolesSplit?: boolean;
	specializationEnabled?: boolean;
	studentPhoneRequired?: boolean;
}): StudentRegisterValidation {
	const {
		formInfo,
		helperInputInfo,
		isSecondName,
		isSmallOlympic,
		skipPassword,
		guardianRolesSplit,
		specializationEnabled = !isSmallOlympic,
		studentPhoneRequired = false,
	} = args;
	const m = studentRegisterErrorMessages;
	const underage = !!formInfo.isStudentUnderage;
	const email = strField(formInfo.email);
	const zipDigits = strField(formInfo.zipCode).replace(/\D/g, '');
	const phone = strField(formInfo.phone);
	const phoneDigits = phone.replace(/\D/g, '');
	const hasTeachers = guardianRolesSplit
		? true // filo: opiekunowie naukowi/szkolni opcjonalni
		: Array.isArray(formInfo.teachersIds) && formInfo.teachersIds.length > 0;

	return {
		titleError: !strField(formInfo.personalTitle) ? m.titleError : '',
		nameError: !strField(formInfo.firstName) ? m.nameError : '',
		parentNameError: underage && !strField(formInfo.parentName) ? m.parentNameError : '',
		secondNameError: isSecondName && !strField(formInfo.secondName) ? m.secondNameError : '',
		surnameError: !strField(formInfo.lastName) ? m.surnameError : '',
		classError: !strField(formInfo.class) ? m.classError : '',
		specializationError: specializationEnabled && !strField(formInfo.specializationId) ? m.specializationError : '',
		emailError: !email ? m.emailError : !isEmail(email) ? 'Niepoprawny adres e-mail' : '',
		phoneError: studentPhoneRequired ? (!phone || phoneDigits.length < 9 ? m.phoneError : '') : '',
		schoolError: !strField(formInfo.schoolId) || !strField(helperInputInfo.school) ? m.schoolError : '',
		districtError: !strField(formInfo.districtId) || !strField(helperInputInfo.district) ? m.districtError : '',
		teacherError: !hasTeachers ? m.teacherError : '',
		streetError: !strField(formInfo.street) ? m.streetError : '',
		buildingError: !strField(formInfo.building) ? m.buildingError : '',
		apartmentError: '',
		zipCodeError: zipDigits.length !== 5 ? m.zipCodeError : '',
		cityError: !strField(formInfo.city) ? m.cityError : '',
		rodoError: !helperInputInfo.rodo ? m.rodoError : '',
		consentError: !helperInputInfo.consent ? m.consentError : '',
		passwordError: skipPassword || strField(formInfo.password).length >= 8 ? '' : m.passwordError,
		passwordConfirmError:
			skipPassword || strField(formInfo.password) === strField(formInfo.passwordConfirm) ? '' : m.passwordConfirmError,
	};
}
